import { getEntitlementValue } from 'app/entitlements';
import { connect } from 'react-redux';
import EntitlementsWrapper from './entitlements-wrapper.jsx';

export function mapStateToProps(state, props) {
  const entitlementValue = getEntitlementValue(state, props);
  return { entitlementValue };
}

export default connect(mapStateToProps)(EntitlementsWrapper);
